var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@fp-suite/core-ui/src/components/Button';
import Table from '@fp-suite/core-ui/src/components/Table';
import React from 'react';
import { useDispatch } from 'react-redux';
import { unpackPallet } from '../redux/authSlice';
import { notification } from 'antd';
var FrieghtPalletInfo = function (_a) {
    var freightPalletInfo = _a.freightPalletInfo, shipmentId = _a.shipmentId, getFreightPalletInfo = _a.getFreightPalletInfo, setIsLoading = _a.setIsLoading;
    var dispatch = useDispatch();
    console.log('freightPalletInfo', freightPalletInfo);
    var freightPalletPackageInfoList = [
        {
            title: (_jsx("div", { children: _jsx("h1", { children: "productId" }, void 0) }, void 0)),
            dataIndex: 'productId',
            render: function (productId) {
                return productId.map(function (item) {
                    return _jsx("h1", { children: item + '\n' }, void 0);
                });
            }
        },
        {
            title: (_jsx("div", { children: _jsx("h1", { children: "Pallet Number" }, void 0) }, void 0)),
            dataIndex: 'containerSerialNumber',
            render: function (containerSerialNumber) {
                return _jsx("h1", { children: containerSerialNumber }, void 0);
            }
        },
        {
            title: (_jsx("div", { children: _jsx("h1", { children: "Pallet Dimension" }, void 0) }, void 0)),
            dataIndex: 'containerLength',
            render: function (containerLength, data) {
                var containerWidth = data.containerWidth, containerHeight = data.containerHeight;
                return _jsx("h1", { children: containerLength + "*" + containerWidth + "*" + containerHeight }, void 0);
            }
        },
        {
            title: (_jsx("div", { children: _jsx("h1", { children: "Pallet Weight" }, void 0) }, void 0)),
            dataIndex: 'containerWeight',
            render: function (containerWeight) {
                return _jsx("h1", { children: containerWeight }, void 0);
            }
        },
        {
            title: (_jsx("div", { children: _jsx("h1", { children: "Unpack Pallet" }, void 0) }, void 0)),
            dataIndex: 'containerSerialNumber',
            render: function (containerSerialNumber, data) {
                var _a;
                return (_jsx(Button, { isDisabled: ((_a = data === null || data === void 0 ? void 0 : data.containerWeight) === null || _a === void 0 ? void 0 : _a.length) === 0, buttonText: 'Unpack', paddingX: 'px-2', onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var activePallet;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    activePallet = freightPalletInfo === null || freightPalletInfo === void 0 ? void 0 : freightPalletInfo.find(function (data) { return data.containerWeight.length === 0; });
                                    if (activePallet) {
                                        notification.error({
                                            message: 'Error',
                                            description: (_jsxs(_Fragment, { children: ["Cannot unpack: Pallet ", _jsx("b", { children: activePallet === null || activePallet === void 0 ? void 0 : activePallet.containerSerialNumber }, void 0), " is in open status."] }, void 0))
                                        });
                                        return [2 /*return*/];
                                    }
                                    setIsLoading(true);
                                    return [4 /*yield*/, dispatch(unpackPallet({
                                            shipmentId: shipmentId,
                                            containerSerialNumber: containerSerialNumber,
                                            getFreightPalletInfo: getFreightPalletInfo
                                        }))];
                                case 1:
                                    _a.sent();
                                    setIsLoading(false);
                                    return [2 /*return*/];
                            }
                        });
                    }); } }, void 0));
            }
        }
    ];
    return (_jsx("div", { children: _jsx(Table, { isPaginated: false, dataSource: freightPalletInfo, columns: freightPalletPackageInfoList }, 'PalletList') }, void 0));
};
export default FrieghtPalletInfo;
